<template>
    <Head>
        <title>Fiat Gateway: Шлюз {{ result.alias }}</title>
    </Head>


    <authenticated-layout :notifications="notifications" >
        <v-navigation :gateway="{id: result.id, name: result.alias}"/>
        <div class="grid grid-cols-3 p-6 gap-6 bg-white items-end">

            <div class="grid grid-cols-3 gap-2 items-end">
                <v-input
                    label="Название"
                    class="col-span-2"
                    v-model="result.alias"
                    @input="disable.alias = false"
                />
                <v-button
                    type="button"
                    :disabled="disable.alias"
                    @click="setAttr('alias', result.alias)"
                >Изменить</v-button>
            </div>

            <div class="grid grid-cols-3 gap-2 items-end">
                <v-input
                    label="Иконка"
                    class="col-span-2"
                    v-model="result.icon"
                    @input="disable.icon = false"
                />
                <v-button
                    type="button"
                    :disabled="disable.icon"
                    @click="setAttr('icon', result.icon)"
                >Изменить</v-button>
            </div>

            <v-toggle label="Активен" v-model="result.isActive" @change="setAttr('active', result.isActive)"/>
        </div>
        <div class="grid grid-cols-3 p-6 gap-6 bg-white items-start">
            <div class="flex flex-col gap-2">
                <div class="flex flex-col">
                    <v-label>Внутренняя валюта</v-label>
                    <strong>{{ result.currency.ticker }} ({{ result.currency.name }})</strong>
                </div>
                <div class="flex flex-col">
                    <v-label>Контроллер</v-label>
                    <strong>{{ result.controller }}</strong>
                </div>
                <div class="flex flex-col">
                    <v-label>Метод</v-label>
                    <strong>{{ result.methodName }}</strong>
                </div>
            </div>

            <div class="col-span-2 flex flex-col gap-2">
                <v-input-json
                    label="Настройки"
                    v-model="result.settings"
                    @input="disable.settings = false"
                />
                <div class="flex flex-row justify-end">
                    <v-button
                        type="button"
                        :disabled="disable.settings"
                        @click="setAttr('settings', result.settings)"
                    >Изменить</v-button>
                </div>
            </div>
        </div>

    </authenticated-layout>
</template>

<script>

import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VNavigation from '@/Components/Navigation/FiatGateways';
import VToggle from '@/Components/Toggle';
import VInput from '@/Components/Input';
import VInputJson from '@/Components/InputJson';
import VLabel from '@/Components/Label';
import VSelect from '@/Components/Select';
import VButton from '@/Components/Button';

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
        VNavigation,
        VToggle,
        VInput,
        VInputJson,
        VLabel,
        VSelect,
        VButton,
    },
    props: {
        success: Boolean,
        result: Object,
        notifications: Array,
    },
    data() {
        return {
            disable: {
                alias: true,
                icon: true,
                settings: true,
            },
            addCred: useForm({
                gatewayId: this.result.id || null,
                name: '',
                isActive: false,
                credentials: {},
            }),
        }
    },
    methods: {
        setAttr(type, val) {
            const { route, notifications, disable, result } = this;
            disable[val] = true;
            notifications.push({
                type: 'success',
                title: `Update ${type}`,
                message: 'Request...',
                timeout: false,
            });
            useForm({value: val})
                .post(route('fiat.gateway.set', [result.id, type]))
        },
    },
};
</script>
